// extracted by mini-css-extract-plugin
export default {"loading_container":"app_loading_container__+mv97"};